import { baseApi } from './base.api';
import { PATH_PLAYGROUND_API } from '../constants/api-routes';
import { getApiVersion } from 'src/utils/apiVersion';

export const playgroundService = baseApi.injectEndpoints({
  endpoints: (build) => {
    return {
      getPlaygroundChat: build.query({
        query: ({ projectId, chatId }) => {
          const version = getApiVersion();

          return {
            url: `${version}/${PATH_PLAYGROUND_API.ROOT}/${projectId}${PATH_PLAYGROUND_API.CHAT}/${chatId}`,
          };
        },
        providesTags: ['PlaygroundChat'],
      }),
      createPlaygroundChat: build.mutation({
        query: ({ projectId }) => {
          const version = getApiVersion();

          return {
            url: `${version}/${PATH_PLAYGROUND_API.ROOT}/${projectId}${PATH_PLAYGROUND_API.CHAT}`,
            method: 'POST',
          };
        },
      }),
    };
  },
});

export const { useLazyGetPlaygroundChatQuery, useCreatePlaygroundChatMutation } = playgroundService;
